<template>
  <b-row>
    <b-col v-if="isLoading">
      <Loader size="lg"></Loader>
    </b-col>
    <b-col v-else>
      <b-row>
        <b-col>
          <router-link v-if="item" :to="{ name: 'EXCMDevicePeripheralList' }" class="btn btn-default float-right">{{$t('buttons.backToList')}}</router-link>
        </b-col>
      </b-row>
      <b-row>
        <b-col>
          <b-card>
            <b-card-title>{{$t('views.excmdeviceperipheral.update.title')}}  {{ item && item['title'] }}</b-card-title>
            <EXCMDevicePeripheralForm
              v-if="item"
              :handle-submit="onSendForm"
              :handle-update-field="updateField"
              :values="item"
              :errors="violations"
              :initial-values="retrieved" />
          </b-card>
        </b-col>
      </b-row>
    </b-col>
  </b-row>
</template>

<script>
import { mapActions, mapGetters } from 'vuex'
import EXCMDevicePeripheralForm from './Form.vue'
import { checkPagePermission } from '@/utils/checkRoles.js'
import Loader from '../../Layout/Loader'

export default {
  components: {
    EXCMDevicePeripheralForm,
    Loader
  },

  data () {
    return {
      item: {}
    }
  },

  beforeCreate () {
    checkPagePermission('devices', 'EXCMDevicePeripheralUpdate')
  },

  computed: {
    ...mapGetters({
      isLoading: 'excmdeviceperipheral/update/isLoading',
      error: 'excmdeviceperipheral/update/error',
      deleteError: 'excmdeviceperipheral/del/error',
      deleteLoading: 'excmdeviceperipheral/del/isLoading',
      created: 'excmdeviceperipheral/create/created',
      deleted: 'excmdeviceperipheral/del/deleted',
      retrieved: 'excmdeviceperipheral/update/retrieved',
      updated: 'excmdeviceperipheral/update/updated',
      violations: 'excmdeviceperipheral/update/violations'
    })
  },

  watch: {
    // eslint-disable-next-line object-shorthand,func-names
    deleted: function (deleted) {
      if (!deleted) {
        return
      }

      this.$router.push({ name: 'EXCMDevicePeripheralList' })
    }
  },

  beforeDestroy () {
    this.reset()
  },

  created () {
    this.retrieve(decodeURIComponent(this.$route.params.id))
  },

  methods: {
    ...mapActions({
      createReset: 'excmdeviceperipheral/create/reset',
      deleteItem: 'excmdeviceperipheral/del/del',
      delReset: 'excmdeviceperipheral/del/reset',
      retrieve: 'excmdeviceperipheral/update/retrieve',
      updateReset: 'excmdeviceperipheral/update/reset',
      update: 'excmdeviceperipheral/update/update',
      updateRetrieved: 'excmdeviceperipheral/update/updateRetrieved'
    }),

    del () {
      if (window.confirm('Are you sure you want to delete this excmdeviceperipheral ?')) {
        this.deleteItem(this.retrieved)
      }
    },

    reset () {
      this.updateReset()
      this.delReset()
      this.createReset()
    },

    onSendForm () {
      this.update()
    },

    updateField (field, value) {
      this.updateRetrieved({ [field]: value })
    }
  }
}
</script>
